import type { AnySchema } from 'yup';
import { object, string, boolean } from 'yup';
import type { TLoginFormFields } from '@features/auth/lib/types';
export const SCHEME = object<Record<keyof TLoginFormFields, AnySchema>>({
  username: string().email('Invalid email format').required('Email is required'),
  password: string().required('Password is required'),
  rememberMe: boolean()
});